/* eslint-disable */
import { TimelineMax, TweenMax } from 'gsap';

export {
    TimelineMax,
    TweenMax
};
